import React, { useContext, useState } from "react";
import { userRepo } from "../repo/user-repo.ts";
import { AppContext } from "../context/app-context.tsx";

const inputClass =
  "w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400";

type Props = {
  userId: number;
  onSuccess?: () => void;
  submitLabel?: string;
};

export default function NotificationSendForm({ userId, onSuccess, submitLabel = "ارسال اعلان" }: Props) {
  const { setMessage } = useContext(AppContext);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isValid = Boolean(title.trim() && content.trim());

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!isValid) {
      setMessage({ type: "error", message: "عنوان و متن اعلان را وارد کنید." });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await userRepo.createNotification({
        user_id: userId,
        title: title.trim(),
        content: content.trim(),
      });
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "ارسال اعلان ناموفق بود." });
        return;
      }

      setMessage({ type: "success", message: "اعلان با موفقیت ارسال شد." });
      setTitle("");
      setContent("");
      onSuccess?.();
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="grid gap-4 md:grid-cols-2">
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">عنوان</span>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={inputClass}
          placeholder="عنوان اعلان"
        />
      </label>
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">متن</span>
        <textarea
          rows={4}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          className={inputClass}
          placeholder="متن اعلان را بنویسید..."
        />
      </label>
      <div className="md:col-span-2">
        <button
          type="submit"
          disabled={!isValid || isSubmitting}
          className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isSubmitting ? "در حال ارسال…" : submitLabel}
        </button>
      </div>
    </form>
  );
}
